<template>
  <div class="pagoda-card-list">
    <slot></slot>
    <card-list-item class="pagoda-card-list-empty-item" v-for="i in emptyItems" :key="`emptyItem_${i}`"></card-list-item>
  </div>
</template>

<script>
  import CardListItem from './card-list-item'
  import {
    addResizeListener,
    removeResizeListener
  } from 'element-ui/lib/utils/resize-event'

  export default {
    name: 'CardList',
    components: {
      CardListItem
    },
    props: {
      itemWidth: {
        type: [Number, String],
        default: 312
      },
      itemHeight: {
        type: [Number, String],
        default: 277
      }
    },
    provide () {
      return {
        cardListInstance: this
      }
    },
    data () {
      return {
        emptyItems: 0
      }
    },
    updated () {
      if (this.$children.length !== this.preCardListItemNum) {
        this.preCardListItemNum = this.$children.length
        this.doLayout()
      }
    },
    mounted () {
      this.preCardListItemNum = this.$children.length

      addResizeListener(this.$el, this.doLayout)
    },
    destroyed () {
      removeResizeListener(this.$el, this.doLayout)
    },
    methods: {
      doLayout () {
        const wrapperWidth = this.$el.clientWidth
        const listItems = this.$el.querySelectorAll('.pagoda-card-list-item-wrapper:not(.pagoda-card-list-empty-item)')
        const listItemsNum = listItems.length
        const listItem = listItems[0]

        if (listItem) {
          const listItemStyle = getComputedStyle(listItem)
          const listItemWidth = parseInt(listItemStyle.marginLeft) + parseInt(listItemStyle.marginRight) + listItem.offsetWidth
          const rowItemNum = Math.floor(wrapperWidth / listItemWidth)
          const surplusNums = listItemsNum % rowItemNum

          if (surplusNums) {
            this.emptyItems = rowItemNum - surplusNums
          } else {
            this.emptyItems = 0
          }
        }
      }
    }
  }
</script>
